/** Sweatpants Component */
import e from"react";import{system as a}from"styled-system";import s from"styled-components";const f=s.div`
  display: flex;
  flex-direction: column;
  ${()=>a({gutter:{property:"paddingBottom",scale:"space"}})}
  ${()=>a({alignment:{property:"alignItems",defaultScale:{center:"center",left:"flex-start",right:"flex-end"}}})}
`,r=e.forwardRef(function(m,o){const{children:i,id:c,align:n,space:d}=m,t=e.Children.toArray(i);return t.length<=1&&!n?e.createElement(e.Fragment,null,t):e.createElement("div",{id:c,ref:o},t.map((p,l)=>e.createElement(f,{key:l,alignment:n,gutter:l<t.length-1?d:null},p)))});r.displayName="Stack",r.defaultProps={space:"1rem"};export{r as Stack};
//# sourceMappingURL=index.esm.js.map
